import { config } from './config';

export default {
  Auth: {
    region: process.env.COGNITO_REGION,
    userPoolId: process.env.COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.COGNITO_USER_POOL_CLIENT_ID,
    oauth: {
      domain: process.env.COGNITO_USER_POOL_DOMAIN,
      redirectSignIn: `${config.env.app.origin}/login`,
      responseType: 'code',
    },
  },
};
